import { store } from '@/store';

export default async function canAccessToAppMiddleware({ next, router }) {
	const validToken = store.isTokenValid();
	if (!validToken) {
		store.onLogout(router.app.$apollo.provider.defaultClient);
		// router.replace({ redirect: '/pages/login' }); No need to redirect anymore, redirection is now handle by the onLogout() methods.
	}
	try {
		next();
	} catch (error) {
		next(false);

		// Force reload the app if chunk fails to load.
		//  it can be caused by the check updateVersion inside routerGuard onBeforeMount did not work successfully.
		if (/loading chunk \d* failed./i.test(error.message)) {
			window.location.reload();
		}
	}
}
